// Basic point calculation function that takes an assigned task object and returns calculated points
export const basicPoints = (assignedTask) => {
  let points = 120;
  points += assignedTask.timer.workTime/1000;
  points *= assignedTask.streak+1;
  return {"points":Math.round(points),"streak":assignedTask.streak+1,"Completion Bonus":120,"Time":Math.round(assignedTask.timer.workTime/1000)};
};
